export default "__VITE_ASSET__b978fba5__"